import isNil from 'lodash-es/isNil';
import { getDeviceCommonName } from '../devices/getDeviceCommonName';
import { isPlot, isStation } from './resourcesTypeCheckers';
/**
 * Simple hook that returns the name of an item
 */
function useItemName(item) {
    let name = '-';
    if (!isNil(item)) {
        if (isPlot(item)) {
            name = item.name;
        }
        else if (isStation(item)) {
            name = item.name;
        }
        else {
            const { endUserName: [, serial] } = item;
            name = `${getDeviceCommonName(item)} (${serial})`;
        }
    }
    return name;
}
export default useItemName;
